import React, { useEffect, useRef, useState } from "react";
import "./WorkExperience.css";

const WorkExperience = ({ sectionTitle, workExperiences = [] }) => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const node = sectionRef.current;
    if (!node) return;

    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    if (prefersReducedMotion) {
      setIsVisible(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15, rootMargin: "0px 0px -8% 0px" }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className={`experience-section${isVisible ? " is-visible" : ""}`}
    >
      <h3 className="section-header">
        <i className="fas fa-briefcase"></i>
        {sectionTitle || "Work Experience"}
      </h3>
      <div className="timeline">
        {workExperiences.map((experience, index) => (
          <div
            key={`${experience.company}-${experience.title}`}
            className="timeline-item"
            style={{ "--item-index": index }}
          >
            <div className="timeline-content">
              <h4 className="job-title">{experience.title}</h4>
              <h5 className="company-name">
                {experience.companyUrl ? (
                  <a className="company-link" href={experience.companyUrl}>
                    {experience.company}
                  </a>
                ) : (
                  <span className="company-link">{experience.company}</span>
                )}
              </h5>
              <span className="duration highlight">{experience.duration}</span>
              {experience.description && (
                <p className="job-description">{experience.description}</p>
              )}
              {experience.technologies && (
                <div className="tech-stack">
                  {experience.technologies.map((tech, idx) => (
                    <span
                      key={idx}
                      className="tech-tag"
                      style={{ "--tag-index": idx }}
                    >
                      {tech}
                    </span>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WorkExperience;
